'use strict';

import dwUtils from '../util';
import * as Utils from '../helpers/born.utils';
import {breakpoints, toggleOverlay, isMobile} from '../helpers/born.utils';
import TrackingLayer from '../modules/module.tracking-layer';
import dwValidator from '../validator';

function addSignupHandler() {
    let form = $('.js-signup-subscribe'),
        subFormSettings = $.extend(true, {submitHandler: sendSignupRequest}, dwValidator.settings),
        ref = $(form).find('[name$=ref]').val();

    dwValidator.initForm(form, subFormSettings);
 
    let page = {
        type:"Sign Up", 
        breadcrumb: ["Home", "Sign Up"]
    };

    if(ref && ref != 'stringEmpty') { 
        page.page_ref = ref; 
    }

    TrackingLayer.pushData(page, 'page');

}

function sendSignupRequest(form) {

    TrackingLayer.pushData('mail_signup: ' + window.Resources['NOSTOCK_SIGNUP']);

    return true;
}

function initEventHandlers() {
	addSignupHandler();
};

exports.init = function () {
    initEventHandlers();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/signuppage.js